import { Combinator } from 'modules/queryBuilder/types';

export const REQUIREMENT_COMBINATOR_LABEL = {
  [Combinator.AND]: 'storybook.combinators.requirement.and',
  [Combinator.OR]: 'storybook.combinators.requirement.or',
  [Combinator.NOT]: 'storybook.combinators.requirement.not',
};

export const DEFAULT_COMBINATOR_LABEL = {
  [Combinator.AND]: 'storybook.combinators.default.and',
  [Combinator.OR]: 'storybook.combinators.default.or',
  [Combinator.NOT]: 'storybook.combinators.default.not',
};
